import { Button } from '@zillow/constellation-10';

import { css, cx } from '@/styled-system/css';
import { shimmerStyles } from '../styles/ShimmerStyles';

import type { ButtonPropsInterface } from '@zillow/constellation-10';
export const LoadingButton = ({
  isLoading,
  loadingWidth,
  children,
  css: cssProp,
  style: styleProp,
  className,
  disabled,
  icon,
  ...rest
}: {
  isLoading: boolean;
  loadingWidth?: string;
} & ButtonPropsInterface) => (
  <Button
    data-loading={isLoading || null}
    className={cx(css(shimmerStyles, cssProp, { _loading: { boxShadow: 'none' } }), className)}
    style={isLoading ? { width: loadingWidth ? loadingWidth : '100%', ...styleProp } : { ...styleProp }}
    icon={isLoading ? null : icon}
    disabled={isLoading ? true : disabled}
    {...rest}
  >
    {isLoading ? <Button.Label>&nbsp;</Button.Label> : children}
  </Button>
);
